import React, { useContext, useState } from 'react';
import { Dropzone } from '@dropzone-ui/react';
import {
  download_icon_small,
  delete_file_paiement_letter,
} from '../../../../utils/images';
import Services from '../../../Services/services';
import { quoteStatus } from '../../../../data/quoteStatus';
import { ExpertContext } from '../../../Contexts/contexts';
import { getPaymentDate } from '../../../../utils/date';
import useToast from '../../../Toasts/useToast';
import {
  ToastHeaders,
  ToastThemes,
  ToastMessages,
} from '../../../Toasts/ToastOptions/toastOptions';

function QuoteElementExpertPrestationModal(props) {
  const expertContext = useContext(ExpertContext);

  // useState pour montrer ou cacher la modal
  const [showModal, setShowModal] = useState(false);

  // useState pour le textArea
  const [text, setText] = useState('');

  const [files, setFiles] = useState([]);

  const [processing, setProcessing] = useState(false);

  const enqueueToast = useToast();

  function closeModal(e) {
    e.stopPropagation();
    setShowModal(false);
  }

  const validateMissionLetter = async () => {
    if (files.length !== 1) {
      enqueueToast('Vous devez sélectionner 1 fichier', {
        theme: ToastThemes.toastThemes.ERROR_OCCURED,
        header: ToastHeaders[ToastThemes.toastThemes.ERROR_OCCURED],
        duration: 5000,
      });
      return;
    }

    /* if (!text.length) {
      enqueueToast('Vous devez renseigner un commentaire', {
        theme: ToastThemes.toastThemes.ERROR_OCCURED,
        header: ToastHeaders[ToastThemes.toastThemes.ERROR_OCCURED],
        duration: 5000,
      });
      return;
    } */

    setProcessing(true);

    let onError = false;

    try {
      const fileNames = files.map(
        (file) => `${Date.now()}_${file.name.replace(/\s/g, '')}`
      );

      const uploadLinks = await Services.documentService.generateUploadLinks(
        fileNames
      );

      for (const [idx, value] of files.entries()) {
        await Services.documentService.uploadFile(value.file, uploadLinks[idx]);
      }

      // create a documentUploaded
      await Services.documentService.createDocumentUploaded(
        files[0].name,
        fileNames[0],
        '9d4d47d6-acfb-4d4b-bb77-876fedc9cc21',
        props?.clientExpertRelation?.clientId,
        props?.clientExpertRelation?.expertId,
        'expert',
        text
      );

      let status = quoteStatus.signed;

      // update the clientExpertRelation
      await Services.quoteService.updateClientExpertRelation(
        props?.clientExpertRelation?.id,
        {
          expertSigned: 1,
          status,
          statusDate: new Date().toISOString(),
        }
      );

      await Services.profileService.createExpertCommission(
        props?.clientExpertRelation?.id,
        getPaymentDate(expertContext.expert?.paymentPeriod, new Date()),
        expertContext.expert?.paymentPeriod
      );
    } catch (error) {
      onError = true;
      console.error(error);
      setProcessing(false);
      enqueueToast(ToastMessages.ERROR_OCCURED_FETCH, {
        theme: ToastThemes.toastThemes.ERROR_OCCURED,
        header: ToastHeaders[ToastThemes.toastThemes.ERROR_OCCURED],
        duration: 3000,
      });
    }

    if (onError) return;

    try {
      await Services.emailService.sendExpertContractClient(
        props?.client?.user?.email,
        'CEC : Félicitation, vous avez contracté avec votre expert-comptable',
        props?.client?.firstName,
        props?.client?.lastName
      );
    } catch (error) {
      console.error(error);
      setProcessing(false);
    }

    expertContext?.refreshClientExpertRelations();
  };

  async function rejectPrestation() {
    try {
      let status = props?.clientExpertRelation?.status;

      if (props?.clientExpertRelation?.clientSigned === 1)
        status = quoteStatus.investigation;
      else status = quoteStatus.rejected;

      // update the clientExpertRelation
      await Services.quoteService.updateClientExpertRelation(
        props?.clientExpertRelation?.id,
        {
          expertSigned: -1,
          status,
          statusDate: new Date().toISOString(),
        }
      );

      await Services.profileService.updateExpertByID(
        expertContext?.expert?.id,
        {
          id: expertContext?.expert?.id,
          nbNewClients: expertContext?.expert?.nbNewClients + 1,
        }
      );

      expertContext?.refreshClientExpertRelations();
    } catch (error) {
      console.error(error);
    }
  }

  return (
    <>
      <div className="signing-statut">
        <div className="did-you-sign">
          Avez-vous effectué une prestation avec ce client ?
        </div>
        <div className="container-signing-button">
          <span onClick={() => rejectPrestation()}>
            Prestation non effectuée
          </span>
          <div className="element-button" onClick={() => setShowModal(true)}>
            Confirmer prestation avec ce client
          </div>
        </div>
      </div>
      {showModal && (
        <div className="container-rdv-modal">
          <div
            className="background-rdv-modal"
            onClick={(e) => closeModal(e)}
          ></div>
          <div className="modal-paiement">
            <div className="modal-paiement-title-details">
              <div className="modal-paiement-title-main">
                Lettre de mission paiement
              </div>
              <div className="modal-paiement-details">
                Veuillez s'il vous plait nous fournir le contrat ou la lettre de
                mission
              </div>
            </div>
            <div className="modal-paiement-client-details-container">
              <div className="modal-paiement-client-name">
                <div className="modal-paiement-title">Nom client</div>
                <div className="client-name">
                  {props?.client?.firstName} {props?.client?.lastName}
                </div>
              </div>
              <div className="modal-paiement-client-number">
                <div className="modal-paiement-title">Numéro client</div>
                <div className="client-number">
                  #{props?.clientExpertRelation?.referenceNumber}
                </div>
              </div>
            </div>
            <div className="sd-container-dropzone width-dropzone">
              <div className="modal-paiement-title">Lettre de mission</div>
              <Dropzone
                color="#4188F2"
                onChange={(files) => setFiles(files)}
                max={1}
                header={false}
                footer={false}
                style={{
                  fontFamily: 'Poppins regular',
                  fontSize: '14px',
                  border: 'none',
                  backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='14' ry='14' stroke='%234188F2FF' stroke-width='2' stroke-dasharray='14' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`,
                }}
                value={files}
              >
                <div className="sd-container-img-label">
                  <img
                    className="img-dwnld"
                    src={download_icon_small}
                    alt="downlad icon small"
                  ></img>
                  <div className="sd-dropzone-title">
                    Envoyer lettre de mission
                  </div>
                </div>
              </Dropzone>
              <div className="modal-file-list modal-prestation-list">
                {files.length > 0 && (
                  <div className="list-files-container" key={files[0]?.id}>
                    <span className="file-name">{files[0]?.name}</span>
                    <img
                      src={delete_file_paiement_letter}
                      className="file-icon"
                      alt="delete file icon"
                      onClick={() => setFiles([])}
                    />
                  </div>
                )}
              </div>
            </div>
            <div className="modal-paiement-comment-container">
              <div className="modal-paiement-title">Commentaire</div>
              <textarea
                className="modal-textarea"
                value={text}
                onChange={(e) => setText(e.target.value)}
                placeholder="Indiquez vos commentaires concernant la lettre de mission"
              ></textarea>
            </div>
            {!processing && (
              <div className="modal-paiement-buttons-container">
                <div
                  className="modal-paiement-next-step-btn"
                  onClick={validateMissionLetter}
                >
                  Valider
                </div>
                <div
                  className="modal-paiement-cancel-btn"
                  onClick={() => setShowModal(false)}
                >
                  Annuler
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default QuoteElementExpertPrestationModal;
